"use client";

import { useNavigate, useSearchParams } from "react-router-dom";
import BusTrackingMap from "@/components/Common/BusTrackingMap";
import BusTabsNav from "./BusTabsNav";

const LiveTrackingMapPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const vehicleId = searchParams.get("vehicleId") || "";
  const shiftId = searchParams.get("shiftId") || "";

  return (
    <div className="space-y-6">
      <BusTabsNav currentTab="tracking" />
      <div className="h-[600px]">
        <BusTrackingMap
          initialVehicleId={vehicleId}
          initialShiftId={shiftId}
          onBack={() => navigate("/dashboard/live-tracking")}
        />
      </div>
    </div>
  );
};

export default LiveTrackingMapPage;
